import { FC, useRef } from "react";

import { WidgetComponentType } from "models/screenshot";

import {
  AutomationHandler,
  useRegisterHandlerWithBroker
} from "components/automation/contexts/AutomationBrokerContext";
import { AutomationCommand } from "components/automation/types/automation";
import { CommandResult } from "components/automation/types/results";
import { Topic, Topics } from "components/automation/types/topics";
import { useScreenshotDispatch } from "components/screenshot/hooks";

import { useMapContext } from "../hooks/useMapContext";

export const MapScreenshotAutomationHandler: FC<{ setScreenshotOverlayVisible }> = ({
  setScreenshotOverlayVisible
}) => {
  const copyOverlayRef = useRef(null);
  const { mapbox } = useMapContext();

  const screenshotDispatch = useScreenshotDispatch();

  const handler: AutomationHandler = {
    id: `open-screenshot-loader`,
    handles: function (topic: Topic): boolean {
      return topic == Topics.OpenMapScreenshot;
    },
    executeCommand: async function (command: AutomationCommand): Promise<CommandResult> {
      if (command.topic !== Topics.OpenMapScreenshot) {
        return;
      }
      const widget = {
        widgetId: "mb",
        widgetComponentType: WidgetComponentType.Map
      };
      screenshotDispatch({
        payload: {
          widget,
          widgetState: {
            mapbox,
            copyOverlay: copyOverlayRef.current
          }
        }
      });
      setScreenshotOverlayVisible(true);

      return Promise.resolve({
        status: "ok"
      });
    }
  };
  useRegisterHandlerWithBroker(handler);
  return <></>;
};
